import React from "react";
import {
  Row,
  Col,
  ConfigProvider,
  Spin,
  Result,
  Button,
  Typography,
  Space,
  theme,
} from "antd";
import { useTranslation } from "react-i18next";
import { useInstitutionProfile } from "../../../../hooks/revi/useInstitutionProfile";
// Importamos desde el barril (index.js) de la nueva carpeta Profile
import {
  InstitutionInfoCard,
  InstitutionPlanCard,
} from "../../../../components/Admin/InstitutionCmp/Profile";
import "./Page_Institution_Profile.scss";

const { Title, Text } = Typography;

export function Page_Institution_Profile() {
  const { t } = useTranslation(["institution", "common"]);

  const { institution, loading, error } = useInstitutionProfile();

  // Hook de tema para usar los colores del sistema sin hardcodear hex
  const { token } = theme.useToken();

  if (loading) {
    return (
      <div className="revi-loader-container">
        <Spin size="large" tip={t("profile.loading")} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="revi-error-container">
        <Result
          status="500"
          title={t("profile.errorTitle")}
          subTitle={error}
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              {t("common:actions.retry")}
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <ConfigProvider>
      <div className="page-institution-profile">
        {/* CABECERA CORREGIDA: Usando Typography y Space */}
        <div style={{ marginBottom: 32 }}>
          <Space orientation="vertical" size={4}>
            <Title
              level={2}
              style={{ margin: 0, color: token.colorTextHeading }}
            >
              {t("profile.title")}
            </Title>
            <Text type="secondary" style={{ fontSize: 16 }}>
              {t("profile.subtitle")}
            </Text>
          </Space>
        </div>

        <Row gutter={[24, 24]}>
          {/* Columna Izquierda: Información Principal */}
          <Col xs={24} md={14} lg={16}>
            <InstitutionInfoCard data={institution} />
          </Col>

          {/* Columna Derecha: Plan y Límites */}
          <Col xs={24} md={10} lg={8}>
            <InstitutionPlanCard
              plan={institution?.planEduca}
              expiry={institution?.expired_at}
            />
          </Col>
        </Row>
      </div>
    </ConfigProvider>
  );
}
